var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { errors } from '@feathersjs/client';
import * as padLeft from 'pad-left';
import * as Raven from 'raven-js';
import { getScoreSystem } from '@crimp/lib-score-systems';
import { feathersServices } from 'src/feathers';
import Divider from 'antd/lib/divider';
import 'antd/lib/divider/style/index.css';
import Form from 'antd/lib/form';
import Icon from 'antd/lib/icon';
import Input from 'antd/lib/input';
import 'antd/lib/input/style/index.css';
import message from 'antd/lib/message';
import 'antd/lib/message/style/index.css';
import Modal from 'antd/lib/modal';
import 'antd/lib/modal/style/index.css';
import 'antd/lib/popover/style/index.css';
import Select from 'antd/lib/select';
import 'antd/lib/select/style/index.css';
import ButtonAction from 'src/pages/components/utilities/ButtonAction';
var FormAthletePromote = (function (_super) {
    __extends(FormAthletePromote, _super);
    function FormAthletePromote(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isFetching: false,
            isVisible: false,
        };
        _this.handleCreateAthleteScore = _this.handleCreateAthleteScore.bind(_this);
        return _this;
    }
    FormAthletePromote.prototype.componentWillReceiveProps = function (nextProps) {
        var currDoc = this.props.athleteScore;
        var nextDoc = nextProps.athleteScore;
        if (currDoc.id !== nextDoc.id) {
            this.props.form.resetFields();
        }
    };
    FormAthletePromote.prototype.handleCreateAthleteScore = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var formValues_1, nextRound, athleteScore, nextAthleteScore, response, prevStatusIcons, nextStatusIcons, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({
                            isFetching: true,
                            isVisible: false,
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4, new Promise(function (resolve, reject) {
                                _this.props.form.validateFieldsAndScroll({ scroll: { offsetTop: 96 } }, function (err, res) {
                                    if (err) {
                                        reject(err);
                                    }
                                    if (!err) {
                                        resolve(res);
                                    }
                                });
                            })];
                    case 2:
                        formValues_1 = _a.sent();
                        nextRound = this.props.rounds.find(function (r) { return r.id === formValues_1.roundId; });
                        if (!nextRound) {
                            throw new errors.GeneralError('We could not find the next round to promote this athlete.');
                        }
                        athleteScore = this.props.athleteScore;
                        nextAthleteScore = {
                            eventId: athleteScore.eventId,
                            roundId: nextRound.id,
                            teamId: athleteScore.teamId,
                            athleteId: athleteScore.athleteId,
                            bibNumber: Number(formValues_1.bibNumber),
                            scoreSystem: nextRound.scoreSystem,
                            summated: getScoreSystem(nextRound.scoreSystem).schema,
                        };
                        return [4, this.props.handleCreateAthleteScore(nextAthleteScore)];
                    case 3:
                        response = _a.sent();
                        if (response.action.type !== feathersServices.athleteScores.types.SERVICES_ATHLETESCORES_CREATE_FULFILLED) {
                            throw new errors.GeneralError('Athlete was not saved');
                        }
                        prevStatusIcons = typeof athleteScore.statusIcons === 'object'
                            ? athleteScore.statusIcons
                            : JSON.parse(athleteScore.statusIcons);
                        nextStatusIcons = !Array.isArray(prevStatusIcons)
                            ? ['IconQualified']
                            : prevStatusIcons.indexOf('IconQualified') === -1
                                ? prevStatusIcons.concat(['IconQualified']) : prevStatusIcons;
                        this.props.handlePatchAthleteScore({
                            id: athleteScore.id,
                            statusIcons: JSON.stringify(nextStatusIcons),
                        });
                        this.setState({ isFetching: false });
                        message.success('Athlete was successfully promoted!');
                        return [3, 5];
                    case 4:
                        err_1 = _a.sent();
                        this.setState({ isFetching: false });
                        Raven.captureException(err_1);
                        if (err_1.message) {
                            message.error(err_1.message);
                        }
                        else {
                            message.error('There are several errors in your data. Please correct them');
                        }
                        return [3, 5];
                    case 5: return [2];
                }
            });
        });
    };
    FormAthletePromote.prototype.render = function () {
        var _this = this;
        var round = this.props.round;
        var athlete = this.props.athlete;
        var athleteScore = this.props.athleteScore;
        this.props.rounds.sort(function (a, b) { return a.index - b.index; });
        var nextRounds = this.props.rounds.filter(function (r) { return r.index > round.index; });
        if (nextRounds.length === 0) {
            return null;
        }
        var nextAthleteScore = this.props.athleteScores
            .filter(function (aS) { return aS.athleteId === athlete.id; })
            .find(function (aS) { return !!nextRounds.find(function (r) { return r.id === aS.roundId; }); });
        if (nextAthleteScore) {
            return (React.createElement(ButtonAction, { isDisabled: true },
                React.createElement("button", null,
                    React.createElement(Icon, { type: 'to-top' }),
                    " Athlete has been promoted")));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(Modal, { title: 'Promote Athlete', visible: this.state.isVisible, wrapClassName: 'vertical-center-modal', onOk: this.handleCreateAthleteScore, onCancel: function () { _this.setState({ isVisible: false }); } },
                React.createElement("h4", null,
                    "Athlete: ",
                    round.code,
                    padLeft(athleteScore.bibNumber, 3, '0'),
                    " - ",
                    athlete.name),
                React.createElement(Divider, null),
                React.createElement(Form, { hideRequiredMark: true },
                    React.createElement(Form.Item, { label: React.createElement("span", null, "Promote to"), colon: false }, this.props.form.getFieldDecorator('roundId', {
                        initialValue: nextRounds[0].id,
                        rules: [{
                                required: true,
                                message: 'Please select a round!',
                            }, {
                                type: 'string',
                            }],
                    })(React.createElement(Select, { size: 'large', style: { width: '100%' } }, nextRounds.map(function (r) { return React.createElement(Select.Option, { key: r.id, value: r.id }, r.name); })))),
                    React.createElement(Form.Item, { label: 'Bib number for next round', colon: false }, this.props.form.getFieldDecorator('bibNumber', {
                        initialValue: padLeft(athleteScore.bibNumber, 3, '0'),
                        rules: [{
                                validator: function (rule, value, callback) {
                                    var bibNumber = Number(value);
                                    if (!Number.isInteger(bibNumber)) {
                                        callback('Bib number must be an integer!');
                                    }
                                    if (bibNumber < 1 || bibNumber > 999) {
                                        callback('Bib number must be between 0-999');
                                    }
                                    callback();
                                },
                            }],
                    })(React.createElement(Input, { size: 'large', style: { width: '100%' } }))))),
            React.createElement("div", null,
                React.createElement(ButtonAction, { isDisabled: this.props.isDisabled, isWaiting: this.state.isFetching },
                    React.createElement("button", { onClick: function () { _this.setState({ isVisible: true }); } },
                        React.createElement(Icon, { type: 'to-top' }),
                        " Promote to next round")))));
    };
    return FormAthletePromote;
}(React.Component));
export default Form.create()(FormAthletePromote);



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/PageDashboard/DashboardForm/DashboardFormTeamAthleteScore/FormPromote/FormAthletePromote.tsx
// module id = 947
// module chunks = 0